export default __webpack_public_path__ + "static/donate-leaves-19fb0294b244f72eefd480f3277bae74.png";